import * as Api from '@ViewModels';

/**
 * Maps a chat role to a human-readable speaker label for the staff coaching review surface.
 * SalesLiveCoaching transcripts use `Assistant` for the AI coach, `User` for the rep, and
 * occasionally `System` for setup/context turns.
 *
 * Shared so the transcript rows (`TranscriptMessage`) and the analytics charts
 * (`ConversationInsights`) label speakers identically.
 */
export const getRoleLabel = (role?: Api.AIChatRole): string => {
	switch (role) {
		case Api.AIChatRole.Assistant:
			return 'AI Coach';
		case Api.AIChatRole.User:
			return 'Rep';
		case Api.AIChatRole.System:
			return 'System';
		default:
			return 'Message';
	}
};
